module.exports = __webpack_public_path__ + "img/polish@2x.4faff19.jpg";